import { prepareCplExtra } from './prepareCplExtra';
import { IProduct, IProductExtra, IProducts } from '../types/analytics';
import { TRecommendation } from '../types/recommendation';

interface IPrepareProduct {
  offer: TRecommendation;
  position: number;
  offersCount: number;
}

interface IPrepareExtra {
  offer: TRecommendation;
  offersCount: number;
}

export const prepareProductExtra = ({ offer, offersCount }: IPrepareExtra): IProductExtra => ({
  identicalOffersCount: offersCount,
  ...prepareCplExtra(offer),
});

export const prepareProduct = ({ offer, position, offersCount }: IPrepareProduct): IProduct => {
  const { offerId: id } = offer;

  return {
    id,
    offerType: 'offer',
    position,
    extra: prepareProductExtra({ offer, offersCount }),
  };
};

export const prepareProducts = (offers: TRecommendation[]): IProducts => {
  return offers.reduce(
    (result, offer, index) => {
      const { offerId: id } = offer;

      result.pages[0].push(id);
      result.entities[id] = prepareProduct({ offer, position: index + 1, offersCount: offers.length });

      return result;
    },
    {
      entities: {},
      pages: [[]],
    } as IProducts,
  );
};
